"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailValid = exports.isPriceValid = exports.validateLength = exports.isValidCAPostalCode = exports.isValidUSPlus4PostalCode = exports.isValidUSPostalCode = exports.isPhoneNumberValid = exports.isValidNumber = void 0;

var _valueCheck = require("../utils/valueCheck");

var isValidNumber = function isValidNumber(value) {
  var regex = /^([-]?)(\d*\.?\d*|\d{1,3}(,\d{3})*(\.\d+)?)$/;
  return regex.test(value);
};

exports.isValidNumber = isValidNumber;

var isPhoneNumberValid = function isPhoneNumberValid(value) {
  var regex = /\(?([2-9]{1}\d{2})\)?([\s.-]{1}?)?([2-9]{1}\d{2})([\s.-]{1}?)?(\d{4})/;
  return regex.test(value);
};

exports.isPhoneNumberValid = isPhoneNumberValid;

var isValidUSPostalCode = function isValidUSPostalCode(value) {
  var regex = /^[0-9]{1}\d{4}$/;
  return regex.test(value);
};

exports.isValidUSPostalCode = isValidUSPostalCode;

var isValidUSPlus4PostalCode = function isValidUSPlus4PostalCode(value) {
  var regex = /^[0-9]{1}\d{4}([ ]?)\d{4}$/;
  return regex.test(value);
};

exports.isValidUSPlus4PostalCode = isValidUSPlus4PostalCode;

var isValidCAPostalCode = function isValidCAPostalCode(value) {
  var regex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
  return regex.test(value);
};

exports.isValidCAPostalCode = isValidCAPostalCode;

var validateLength = function validateLength(value, lengthLimit, direction) {
  if ((0, _valueCheck.isValueFalsey)(lengthLimit)) return false;

  switch (direction) {
    case "lessThan":
      return value.length < lengthLimit;

    case "greaterThan":
      return value.length > lengthLimit;

    case "equalTo":
      return value.length === lengthLimit;

    default:
      return false;
  }
};

exports.validateLength = validateLength;

var isPriceValid = function isPriceValid(value) {
  var priceRegex = /^[-]?[$]?\d+(,\d{3})*((.)\d{0,2})?$/;
  return priceRegex.test(value);
};

exports.isPriceValid = isPriceValid;

var isEmailValid = function isEmailValid(emailAddress) {
  // Source: http://emailregex.com/
  var regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regEx.test(emailAddress.trim());
};

exports.isEmailValid = isEmailValid;